import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';

import Component from 'vue-class-component';
import Login from '@/views/Login.vue';
import BundleIndex from '@/views/main/bundle/Index.vue';
import BundleOverviewIndex from '@/views/main/bundle/overview/Index.vue';
import BundleByIdIndex from '@/views/main/bundle/_bundleId/Index.vue';

Vue.use(Router);

Component.registerHooks(['beforeRouteUpdate']);

const createRouter = () =>
  new Router({
    routes: [
      {
        path: '/login',
        name: 'login',
        component: Login
      },
      {
        path: '/bundle',
        component: BundleIndex,
        children: [
          {
            path: 'overview',
            component: BundleOverviewIndex,
            meta: {
              displayName: 'Beitragsübersicht'
            }
          },
          {
            path: ':bundleId',
            component: BundleByIdIndex,
            meta: {
              displayName: 'Beitragsstatistiken'
            }
          },
          {
            path: '/',
            redirect: 'overview'
          }
        ]
      },
      {
        path: '/',
        redirect: 'bundle'
      }
    ]
  });

const router = createRouter();

router.beforeEach((to, from, next) => {
  if (!!to && !!to.meta && !!to.meta.displayName) {
    store.commit('application/changeTitle', to.meta.displayName);
  } else {
    store.commit('application/changeTitle', '');
  }

  const publicPages = ['login'];
  const authRequired = !publicPages.includes(to.name as string);

  const isLoggedIn = store.state.user.isLoggedIn;

  if (authRequired && !isLoggedIn) {
    return next('login');
  }

  if (isLoggedIn && publicPages.includes(to.name as string)) {
    return next('/');
  }

  return next();
});

export default router;
